import { BUILD_ENVIRONMENT } from './environment.build';

export type Environment = 'dev' | 'sit' | 'stage' | 'prod';

export interface EnvironmentConfig {
  name: string;
  apiBaseUrl: string;
  logLevel: 'debug' | 'info' | 'warn' | 'error';
}

export class EnvironmentDetector {
  static getEnvironment(): Environment {
    return BUILD_ENVIRONMENT;
  }


  static getEnvironmentConfig(): EnvironmentConfig {
    const env = this.getEnvironment();

    const configs: Record<Environment, EnvironmentConfig> = {
      dev: {
        name: 'Development',
        apiBaseUrl: 'http://localhost:3000',
        logLevel: 'debug',
      },
      sit: {
        name: 'System Integration Testing',
        apiBaseUrl: 'https://api-sit.example.com',
        logLevel: 'info',
      },
      stage: {
        name: 'UAT Acceptance Testing',
        apiBaseUrl: 'https://api-stage.example.com',
        logLevel: 'info',
      },
      prod: {
        name: 'Production',
        apiBaseUrl: 'https://api.example.com',
        logLevel: 'warn',
      },
    };

    return configs[env];
  }
}
